export default __webpack_public_path__ + "static/media/screen5.6ba03f6e.png";